import request from '../services/request';

export function search(data) {
  return request({
    url: `/torniquet/search`,
    method: 'POST',
    data,
  });
}

export function searchTorniquets(data, page) {
  return request({
    url: `/torniquet/search?page=${page}`,
    method: 'POST',
    data,
  });
}

export function indexTorniquet() {
  return request({
    url: `/torniquet`,
    method: 'GET',
  });
}

export function getTorniquetById(id, data) {
  return request({
    url: `/torniquet/${id}`,
    method: 'GET',
    data,
  });
}

export function storeTorniquet(data) {
  return request({
    url: `/torniquet`,
    method: 'POST',
    data,
  });
}

export function updateTorniquet(id, data) {
  return request({
    url: `/torniquet/${id}`,
    method: 'PUT',
    data,
  });
}

export function deleteTorniquet(id) {
  return request({
    url: `/torniquet/${id}`,
    method: 'DELETE',
  });
}

export function statusTorniquet(id, data) {
  return request({
    url: `/torniquet/${id}/status`,
    method: 'PUT',
    data,
  });
}

export function exportFile(data, configs) {
  return request({
    url: `/torniquet/export`,
    method: 'POST',
    responseType: 'blob',
    data,
    ...configs,
  });
}

export function getAnalyticsTorniquet(data) {
  return request({
    url: `/torniquet/dashboard/analytics`,
    method: 'POST',
    data,
  });
}

// -------------- Catalogos para combobox ------------------------
export function catalogCompanies() {
  return request({
    url: `/torniquet/catalog/companies`,
    method: 'GET',
  });
}

export function catalogLocations(data) {
  return request({
    url: `/torniquet/catalog/locations`,
    method: 'POST',
    data,
  });
}

export function catalogBuildings(data) {
  return request({
    url: `/torniquet/catalog/building`,
    method: 'POST',
    data,
  });
}

export function catalogZones(data) {
  return request({
    url: `/torniquet/catalog/zone`,
    method: 'POST',
    data,
  });
}

export function catalogAccessTypes() {
  return request({
    url: `/torniquet/catalog/access-type`,
    method: 'GET',
  });
}

export function resetTorniquet(id) {
  return request({
    url: `/torniquet/${id}/reset`,
    method: 'PUT',
  });
}
